/**
 * Standard CKEditor5 plugins used in CC Editor
 */
import { AIAssistant, OpenAITextAdapter } from 'ckeditor5-premium-features';
import CustomOpenAITextAdapter from "./plugins/custom/CustomOpenAITextAdapter";
import {
	Essentials,
	Paragraph,
  ParagraphButtonUI,
	Alignment,
	Autoformat,
	BlockQuote,
  Bold,
  Italic,
  Subscript,
  Superscript,
  Strikethrough,
  Underline,

  FontBackgroundColor,
  FontColor,
  FontFamily,
  Font,

	Heading,
  HeadingButtonsUI,
	HorizontalLine,
	Indent,
	IndentBlock,
	Link,
  LegacyList,
  LegacyListProperties,
	// List,
	// ListEditing,
	// ListProperties,
	MediaEmbed,

	// Placeholder,
	RemoveFormat,
	SpecialCharactersText,
	SpecialCharactersMathematical,
	SpecialCharactersEssentials,
	SpecialCharactersCurrency,
	SpecialCharactersLatin,
	SpecialCharactersArrows,
	SpecialCharacters,
	Table,
	TableToolbar,
	TableCellProperties,
	TableProperties,
  TableColumnResize,
	TextTransformation,
	WordCount
} from 'ckeditor5';


export default [
  Essentials,
  Paragraph,
  ParagraphButtonUI,
  Alignment,
  Autoformat,
  BlockQuote,
  Bold,
  Italic,
  Subscript,
  Superscript,
  Strikethrough,
  Underline,

  FontBackgroundColor,
  FontColor,
  FontFamily,
  Font,

  Heading,
  HeadingButtonsUI,
  HorizontalLine,
  Indent,
  IndentBlock,
  Link,
  LegacyList,
  LegacyListProperties,
  // List,
	// ListEditing,
  // ListProperties,
	MediaEmbed,

  // Placeholder, // not available in ckeditor5
  RemoveFormat,
  SpecialCharactersText,
  SpecialCharactersMathematical,
  SpecialCharactersEssentials,
  SpecialCharactersCurrency,
  SpecialCharactersLatin,
  SpecialCharactersArrows,
  SpecialCharacters,
  Table,
  TableToolbar,
  TableCellProperties,
  TableProperties,
  TableColumnResize,
  TextTransformation,
  WordCount,

  AIAssistant,
  CustomOpenAITextAdapter,
  //OpenAITextAdapter,
];
